import customerCache from './customer.vue'
import ccCustomerCacheNew from './customerNew.vue'
export let CustomerCacheNew = ccCustomerCacheNew
export default customerCache



// WEBPACK FOOTER //
// ./pagesCache/customer/index.js